import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AutoritaGiudiziaria } from "../../../common/models/tipologiche/autorita-giudiziaria";
import { SedeTerritoriale } from "../../../common/models/tipologiche/sede-territoriale";
import { TipoIndaginePreliminare } from "../../../common/models/tipologiche/tipo-indagine-preliminare";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { FormValidationService } from "../../../common/services/form-validation.service";
import { HelpersService } from "../../../core/services/helpers.service";
import { OperationsService } from "../../../core/services/operations.service";
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';
import { DatiGeneraliConFondoRischiForm } from 'src/app/common/form/dati-generali-con-fondo-rischi-form';

@Component({
  selector: 'app-form-indagini-preliminari',
  templateUrl: './form-indagini-preliminari.component.html',
  styleUrls: ['./form-indagini-preliminari.component.css']
})
export class FormIndaginiPreliminariComponent extends DatiGeneraliConFondoRischiForm implements OnInit, OnChanges {
  datiGeneraliForm: FormGroup;
  tipiIndaginePreliminare: TipoIndaginePreliminare[] = [];
  tipiNatura: TipoNatura[] = [];
  cittaPerAutoritaGiudiziaria: SedeTerritoriale[] = [];
  idPratica: string;
  tipoFascicolo: string;
  tipoPratica: number;
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(protected operationService: OperationsService,
              private formValidationService: FormValidationService,
              private campiForm: FormBuilder,
              private helpers: HelpersService) { super(); }

  ngOnInit() {
    this.createFascicoloForm(true);
    //this.request.fascicolo.natura = null;
    this.inizializzaFondoRischi(this.request.fascicolo.flagFondoRischi, this.request.fascicolo.dataVariazioneFondoRischi);
    this.populateSelect();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura],
      stato: [init ? null : this.request.fascicolo.stato],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      definito: [init ? null : this.request.fascicolo.definito],
      dataDefinizione: [init ? null : this.request.fascicolo.dataDefinizione],
      motivoDefinizione: [init ? null : this.request.fascicolo.motivoDefinizione],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      recuperoCrediti: [init ? false : this.request.fascicolo.recuperoCrediti],
      //dataVariazioneFondoRischi: [init ? null : this.request.fascicolo.dataVariazioneFondoRischi],
      flagProcessoTelematico: [init ? null : this.request.fascicolo.flagProcessoTelematico],
      nruolo: [init ? null : this.request.fascicolo.numeroRuolo],
      annoRuolo: [init ? null : this.request.fascicolo.annoRuolo, Validators.compose([this.formValidationService.anno])],
      autoritaGiudiziaria: [init ? null : this.request.fascicolo.autoritaGiudiziaria],
      autoritaGiudiziariaCitta: [init ? null : this.request.fascicolo.autoritaGiudiziariaCitta, Validators.required],
      tipoIndaginePreliminare: [init ? null : this.request.fascicolo.tipoIndaginePreliminare],
      giudiceIndaginiPreliminari: [init ? null : this.request.fascicolo.giudiceIndaginiPreliminari],
      giudiceUdienzaPreliminare: [init ? null : this.request.fascicolo.giudiceUdienzaPreliminare],
      pubblicoMinistero: [init ? null : this.request.fascicolo.pubblicoMinistero],
      incidenteProbatorio: [init ? null : this.request.fascicolo.incidenteProbatorio],
      richiestaOblazione: [init ? null : this.request.fascicolo.richiestaOblazione],
      prove: [init ? null : this.request.fascicolo.prove],
      sufficienzaProve: [init ? null : this.request.fascicolo.sufficienzaProve],
      richiestaArchiviazione: [init ? null : this.request.fascicolo.richiestaArchiviazione],
      dataRichiestaArchiviazione: [init ? null : this.request.fascicolo.dataRichiestaArchiviazione],
      rimandoAlPM: [init ? null : this.request.fascicolo.rimandoAlPM],
      richiestaRinvioAGiudizio: [init ? null : this.request.fascicolo.richiestaRinvioAGiudizio],
      misureCautelari: [init ? null : this.request.fascicolo.misureCautelari],
      misuraAdottata: [init ? null : this.request.fascicolo.misuraAdottata],
      note: [init ? null : this.request.fascicolo.note],
      capofila: [init ? null : this.request.fascicolo.capofila],
      riunito: [init ? null : this.request.fascicolo.riunito],
      dataRiunioneGiudizio: [init ? null : this.request.fascicolo.dataRiunioneGiudizio],
      motivoRiunioneGiudizio: [init ? null : this.request.fascicolo.motivoRiunioneGiudizio],
      dataOpposizioneArchiviazione: [init ? null : this.request.fascicolo.dataOpposizioneArchiviazione],
      opposizioneArchiviazione: [init ? null : this.request.fascicolo.opposizioneArchiviazione],
      giudice: [init ? null : this.request.giudice],
      //sezione: [init ? null : this.request.fascicolo.sezione],
      grado: [init ? null : this.request.fascicolo.grado],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
      dataPrimaComparizione:[init ? null : this.request.fascicolo.dataPrimaComparizione],
      dataDepositoRicorso: [init ? null : this.request.fascicolo.dataDepositoRicorso],
      flagCostituzione:[init ? true : this.request.fascicolo.flagCostituzione],
      motivazione: [init ? null : this.request.fascicolo.motivazione],      
      dataCostituzione: [init ? null : this.request.fascicolo.dataCostituzione],
      
    });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  populateSelect() {

    if (this.tipiIndaginePreliminare.length === 0) {
      this.helpers.getTipiIndaginePreliminare().subscribe(response => this.tipiIndaginePreliminare = response);
    }
  }

  gestCitta(autoritaGiudiziaria: AutoritaGiudiziaria[]) {
    let ind = autoritaGiudiziaria.findIndex(t => t.descrizione.toUpperCase() === 'TRIBUNALE');
    if (ind >= 0) {
      let idAutorita = autoritaGiudiziaria[ind].id;
      this.helpers.getCittaPerAutoritaGiudiziaria(idAutorita).subscribe(response => this.cittaPerAutoritaGiudiziaria = response);
    }
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }

  save() {
    this.saveForm.emit();
  }
}
